import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import { u3125FormatCreditApplicationNature, type U3125InvoiceCreditApplicationGridRow } from "../../../../U3125Service";
import type { U3125CreditApplicationHandlerReturn } from "./U3125CreditApplicationHandlers";

interface U3125CreditApplicationDeleteDlgProps {
  u3125CreditApplicationHandler: U3125CreditApplicationHandlerReturn;
  t: TFunction;
  NS: string;
}

function U3125CreditApplicationDeleteDlg({ u3125CreditApplicationHandler, t, NS }: U3125CreditApplicationDeleteDlgProps) {
  if (!u3125CreditApplicationHandler.isDeleteDialogOpen) return null;

  return (
    <U2000DeleteRecordDialog
      isOpen={u3125CreditApplicationHandler.isDeleteDialogOpen}
      onClose={u3125CreditApplicationHandler.onDlgDeleteClose}
      title={t("sectionCreditApplications", { ns: NS })}
    >
      <p className="mb-4">
        {t("msgDeleteCreditApplications", {
          count: u3125CreditApplicationHandler.gridStateHandlers.getSelectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {u3125CreditApplicationHandler.gridStateHandlers.getSelectedRows().map((row: U3125InvoiceCreditApplicationGridRow, index, array) => {
          const num = row.sourceInvoiceNumber != null ? String(row.sourceInvoiceNumber) : "—";
          const nature = u3125FormatCreditApplicationNature(row.sourceNature, t, NS);
          return (
            <span key={row.id} className="inline-block text-gray-800">
              {`${num} (${nature})`}
              {index < array.length - 1 && ", "}
            </span>
          );
        })}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3125CreditApplicationDeleteDlg;
